import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=2dbc5b09&scoped=true&"
import script from "./Head.vue?vue&type=script&lang=ts&"
export * from "./Head.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc5b09",
  null
  
)

export default component.exports